<template>
  <div class="modal fade" :id="id" tabindex="-1" role="dialog"  aria-hidden="true">
    <div v-if="show !== false" class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="color-line"></div>
        <div class="modal-header">
          <h4 class="modal-title">File details</h4>
        </div>
        <div class="modal-body">
          <Details v-if="file_id" :file_id="file_id"></Details>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Details from '../file/Details'

export default {
  name: 'FileDetails',
  components: {Details},
  data () {
    return {
      id: null,
      show: false,
      file_id: null
    }
  },
  methods: {
    openModal: function () {
      this.show = true

      setTimeout(() => {
        $('#' + this.id).modal('show')
      }, 200)

      $('#' + this.id).on('hide.bs.modal', () => {
        this.show = false
      })
    },
    setFileId: function (fileId) {
      this.file_id = fileId
    }
  },
  beforeMount () {
    this.id = '_' + Math.random().toString(36).substr(2, 9)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modal/FileDetails.vue